import React from 'react';

const ActivityFeed = () => {
  return (
    <div className="activity-feed">
      <h1>Activity Feed</h1>
      <div className="activity-feed-content">
        {/* Activity Feed content will go here */}
      </div>
    </div>
  );
};

export default ActivityFeed; 